const miniColors = [
  {
    accountId: '29369',
    bg1: '#F0F0F3',
    bg2: '#FFFFFF',
    bg3: '#4E217C',
    'font-color1': '#1D2129',
    'font-color2': '#606266',
    'font-color3': '#646566'
  },
  {
    accountId: '95819',
    bg1: '#F0F0F3',
    bg2: '#FFFFFF',
    bg3: '#4E217C',
    'font-color1': '#1D2129',
    'font-color2': '#606266',
    'font-color3': '#646566'
  }
]

export { miniColors }